/** TanStack Query keys for classic rewards APIs (svc-lux-loyalty). */
export const rewardsQueryKeys = {
  all: ['rewards'] as const,

  catalogs: () => [...rewardsQueryKeys.all, 'catalogs'] as const,
  catalogsList: (filters: { itemType?: string; status?: string }) => [...rewardsQueryKeys.catalogs(), filters] as const,

  entries: () => [...rewardsQueryKeys.all, 'entries'] as const,
  entriesList: (filters: {
    catalogId: string;
    itemType: string;
    itemSubType: string;
    itemReferences?: Array<string>;
  }) => [...rewardsQueryKeys.entries(), filters] as const,

  inventory: () => [...rewardsQueryKeys.all, 'inventory'] as const,
  inventoryByEntry: (catalogEntryId: string) => [...rewardsQueryKeys.inventory(), catalogEntryId] as const,

  reservations: () => [...rewardsQueryKeys.all, 'reservations'] as const,
  reservationsSearch: (params: Record<string, unknown>) =>
    [...rewardsQueryKeys.reservations(), 'search', params] as const,
  reservationsByOrder: (orderId: string) => [...rewardsQueryKeys.reservations(), 'order', orderId] as const,
};
